module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "核销优惠券",
      "visible": _vm.dialogVisible,
      "width": "30%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "formRef",
    attrs: {
      "model": _vm.formData,
      "label-position": 'right',
      "size": "mini",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "会员信息"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.subscriberInfo),
      callback: function($$v) {
        _vm.subscriberInfo = $$v
      },
      expression: "subscriberInfo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "优惠券名称"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.formData.couponName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "couponName", $$v)
      },
      expression: "formData.couponName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "优惠券编码"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.formData.couponCode),
      callback: function($$v) {
        _vm.$set(_vm.formData, "couponCode", $$v)
      },
      expression: "formData.couponCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "核销事由",
      "prop": "reason"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "maxlength": "255"
    },
    model: {
      value: (_vm.formData.reason),
      callback: function($$v) {
        _vm.$set(_vm.formData, "reason", $$v)
      },
      expression: "formData.reason"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-popconfirm', {
    attrs: {
      "title": "确定核销吗?"
    },
    on: {
      "onConfirm": _vm.dataFormSubmit
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "reference",
      "type": "primary"
    },
    slot: "reference"
  }, [_vm._v("确定")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-3b79991c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/biz/subscriber/components/couponConsume.vue
// module id = 1634
// module chunks = 0